import { ApiError, ApiErrorWithDetail } from "../api";

export default function getApiErrorHasDetail(
  error: unknown
): error is ApiErrorWithDetail {
  return (
    error instanceof ApiError &&
    typeof error.info === "object" &&
    error.info !== null &&
    "detail" in error.info
    // TODO: more checks...
  );
}
